import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { createSelector } from '@ngrx/store';
import { getOpenAccountState } from '@store/index';
import { InternalTransferState } from '@store/reducers/internal-transfer/internal-transfer.reducer';
import { IOpenAccountState } from '@store/reducers/open-account/open-account.reducer';
import {
  selectInternalTransferFrom,
  selectInternalTransferHasAvgCostHoldings,
  selectInternalTransferState,
} from '@store/selectors/internal-transfer/internal-transfer.selectors';
import { selectSettlementFundChoice } from '@store/selectors/open-account/open-account.selectors';

import {
  selectEmploymentReceipt,
  selectFinancialProfileReceipt,
  selectProfileReceipt,
} from '../new-account/new-account.selectors';
import { selectVCDSettlementFundsToggle } from './../../feature/feature.selectors';
import {
  buildAccountFromInternalTransfer,
  buildAccountToInternalTransfer,
} from './cashier-internal-transfer';

export const selectAccountFromInternalTransferReceipt = (editable: boolean) => {
  return createSelector(
    selectInternalTransferFrom,
    selectInternalTransferHasAvgCostHoldings,
    (transferFrom: InternalTransferState['transferFrom'] | null, hasAvgCostHoldings: boolean) =>
      buildAccountFromInternalTransfer(transferFrom, editable, hasAvgCostHoldings),
  );
};

export const selectAccountToInternalTransferReceipt = (editable: boolean) => {
  return createSelector(
    selectInternalTransferState,
    getOpenAccountState,
    selectSettlementFundChoice,
    selectVCDSettlementFundsToggle,
    (
      state: InternalTransferState,
      openAccountState: IOpenAccountState,
      settlementFundChoice: SettlementFundAoAEnum | null,
      isVCDToggleOn: boolean,
    ) =>
      buildAccountToInternalTransfer(
        state,
        openAccountState,
        editable,
        settlementFundChoice,
        isVCDToggleOn,
      ),
  );
};

export const selectInternalTransferReceiptData = (editable: boolean = true) => {
  //TODO: either create new selectors for IT, or update the below selectors to read from IT for transactionType instead of selectedClientAccounts.
  return createSelector(
    selectAccountFromInternalTransferReceipt(editable),
    selectAccountToInternalTransferReceipt(editable),
    selectProfileReceipt(editable),
    selectEmploymentReceipt(editable),
    selectFinancialProfileReceipt(editable),
    (from, to, profile, employment, financial) => {
      return {
        from,
        to,
        profile,
        employment,
        financial,
      };
    },
  );
};
